import 'core-js/es6/symbol';
import 'babel-polyfill';
import '../components/UI/boxAlert/boxAlert'
import '../components/popup/popup'
import '../components/popup/popupGeneric'
import '../components/UI/ribbon/ribbon'
import designer from '../components/productDetails/designer'

import PamiatkiTopSlider from '../components/pamiatkiTopSlider/PamiatkiTopSlider';

import Page from '../extendable/Page';

import $ from 'jquery';

import 'webpack-jquery-ui';
import 'jquery-colorbox';
import {App} from './App';
import axios from 'axios';

import jssocials from '../components/jssocials/jssocials';


class Main extends Page {
	
	constructor() {
		super();
	};
	
	removeFromFavoriteHandler() {
		let removeFromFav = document.querySelectorAll('.js-remove-from-favorite');
		
		if (removeFromFav) {
			removeFromFav.forEach(link => {
				link.addEventListener('click', function (e) {
					e.preventDefault();
					
					let c = confirm(link.dataset['question']);
					if (c === true) {
						axios.get(link.dataset['href']).then(response => {
							if (response.data.status == 'success') {
								document.querySelector(link.dataset['target']).remove();
							} else {
								console.log('error: ' + response.data.msg);
							}
						});
					}
				});
			});
		}
	}
	
	loadPredefinedOrderData() {
		$(document).on("change", ".JS_predefined_order_data", function (e) {
			e.preventDefault();
			const id = $(this).val();
			const prefix = $(this).data('prefix');
			const form = $($(this).data('form'));
			
			if (form && id) {
				axios(`pobierz-dane,${id}.html`).then(({data: receivedData}) => {
					$.each(receivedData, (key, value) => {
						form.find(`[name="${prefix}[${key}]"]`).val(value);
					});
				});
			}
			
		});
	}
	
	initPamiatkiSlider() {
		let isPamiatkiPage = document.body.classList.contains('pamiatkislubne');
		
		isPamiatkiPage ?
			PamiatkiTopSlider() :
			null;
		
	}
	
	initJSsocials() {
		jssocials({
			selector: '#js-news-socials'
		});
	}
	
	customOnClickBtn() {
		Array.from(document.querySelectorAll(".js-button-trigger")).forEach(element => {
			element.addEventListener("click", e => {
				e.preventDefault();
				
				let self = e.currentTarget;
				let target = document.querySelector(self.dataset.target);
				
				if (target) {
					target.click();
				}
			});
		});
	}
	
	boot() {
		$(document).ready(() => {
			window.app = new App();
			
			let des = designer();
			let _cboxClose = $.colorbox.close;
			
			let callbacks = {
				onCloseDesigner: function () {
					des.onCloseDesigner();
				},
				
				onBeforeCloseDesigner: () => {
					if (confirm('R U Sure?')) {
					
					}
				}
			};
			
			$('.js-color-info').colorbox({
				inline: true,
				href: function () {
					console.log($(this).attr('href'));
					return $(this).attr('href');
				},
				maxWidth: '95%',
				maxHeight: '95%',
				width: 600,
				height: 300,
				current: "{current} / {total}"
			});
			
			$('.js-colorbox').colorbox({
				maxWidth: '95%',
				maxHeight: '95%',
				current: "{current} / {total}"
			});
			
			$('.js-colorbox-iframe').each(function (i, item) {
				let opts = {
					maxWidth: '95%',
					maxHeight: '95%',
					width: 1920,
					height: 1080,
					iframe: true,
					fixed: true,
					current: "{current} / {total}",
					href: this.href,
					overlayClose: false
				};
				
				if (item.dataset.callback && callbacks.hasOwnProperty(item.dataset.callback) && typeof callbacks[item.dataset.callback] === "function") {
					opts['onClosed'] = callbacks[item.dataset.callback];
					/*$.colorbox.close = function() {
						if(confirm('Close?')) {
							_cboxClose();
						}
					};*/
				}
				
				if (item.dataset.close && item.dataset.close === 'hidden') {
					opts.className = 'hiddenClose';
				}
				
				$(item).colorbox(opts);
			});
			
			/*$('.js-colorbox-iframe').colorbox({
				maxWidth: '100%',
				maxHeight: '100%',
				width: 1920,
				height: 1080,
				iframe: true,
				fixed: true,
				current: "{current} / {total}"
			});*/
			
			let showBody = app.animationEvents.showBody(1000);
			
			showBody.then(() => {
				app.animationEvents.showSliderLabels(1000);
			});
			
			this.loadPredefinedOrderData();
			this.initPamiatkiSlider();
			this.initJSsocials();
			this.customOnClickBtn();
			this.removeFromFavoriteHandler();
		});
	}
}

new Main().boot();


// WEBPACK FOOTER //
// ./js/main.js